import React from 'react'
import btnStyle from "./Mycustombutton.module.css"
export const Mycustombutton = ({label,onClick,key}) => {
  return (
    <button key={key} onClick={onClick} className={btnStyle.actionBtn}>
        {label}
      </button>
  )
}
